import { createAsyncThunk } from '@reduxjs/toolkit'
import Log from './log-model'
import { delete_log, load_logs, store_log } from './log-service'

export const LoadLogsAsync = createAsyncThunk<any, any>(
  'composer/load/log',
  async (params: { uid: string }) => {
    return await load_logs(params)
  },
)

export const CreateLogAsync = createAsyncThunk<any, any>(
  'composer/create/log',
  async (params: Log) => {
    return await store_log(params)
  },
)

export const DeleteLogAsync = createAsyncThunk<any, any>(
  'composer/delete/log',
  async (params) => {
    return await delete_log(params)
  },
)
